import { Box, Card, CircularProgress, Grid } from '@mui/material'
import clsx from 'clsx'

import { useStylesTheme } from '../../config'

const LoadingPage = () => {
    return (
        <Box height='100%'>
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={clsx('pageCard', 'noNavBarMargin')}>
                        <Grid container style={{ height: '100%' }} alignItems='center' justifyContent='center'>
                            <Grid container item spacing={8} justifyContent='center'>
                                <Grid item>
                                    <CircularProgress size={200}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default LoadingPage
